import React, { Component } from "react";

import LogRocket from "logrocket";
import NoRecoveryRestaurantId from "../components/admin/NoRecoveryRestaurantId";
import { HashRouter as Router, Switch, Redirect } from "react-router-dom";
import TemplateWrapper from "../components/admin/TemplateWrapper";
import Presentation from "../components/admin/Presentation";
import Publication from "../components/admin/Publication";
import { fetcher } from "../services/sagas/fetcher.saga";
import Logistics from "../components/admin/Logistics";
import NewOrder from "../components/admin/NewOrder";
import General from "../components/admin/General";
import Address from "../components/admin/Address";
import HoursV3 from "../components/admin/HoursV3";
import Stripe from "../components/admin/Stripe";
import Carte from "../components/admin/Carte";
import { FormattedMessage } from "react-intl";
import PropsRoute from "../utils/PropsRoute";
import { SnackbarProvider } from "notistack";
import Menu from "../components/admin/Menu";
import Loader from "react-loader-spinner";
import "../sass/Admin.scss";
import CallApi from "../utils/CallApi";
import config from "../config";
import { subUserTools, UnauthorizedServicePage, SubUserHeader } from "@capps/subuser-tools";
import { getCookieValue } from "../utils/utils";

class IndexAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayScreenCloseDates: false,
      restaurantId: "",
      name: "",
      slogan: "",
      email: "",
      emailContact: "",
      phone: "",
      idAddress: "",
      openingDate: {},
      deliveryArea: [],
      deliveryActive: false,
      deliveryMin: "",
      deliverySup: "",
      deliveryFreeSurcharge: "",
      takeAwayActive: "",
      takeAwayMin: "",
      takeAwaySup: "",
      facebookUserId: "",
      facebookPageId: "",
      closingDate: {},
      stripeAvailable: false,
      disabledApp: {
        active: false,
        period: null,
      },
      restaurantAddress: {
        id: "",
        street: "",
        streetNumber: "",
        zipCode: "",
        city: "",
        country: "",
        lat: "",
        long: "",
        additionalAddress: "",
      },
      createAccountError: null,
      unauthorizedSubUser: false,
      errors: "",
      mobile: false,
      menu: "",
      token: getCookieValue('refreshToken'),
      accessToken: "",
      loader: true,
      timePrepareOrder: "",
      automaticallyValidated: null,
      currencies: [],
      currency: "",
      restaurantAlias: "",
      description: "",
      selectedImages: [],
      orderShiftClose: null,
      slotAuto: false,
      slotDuration: 15,
      slotMaxOrderCount: null,
      slotMaxProductsCount: null,
      rulesStatus: ""
    };
  }

  isProd = window.location.hostname === "commande-en-ligne.laddition.com";

  componentDidMount() {
    this.getRestaurantInfo();
  }

  async componentDidUpdate(_, prevState) {
    if (this.state.rulesStatus) {
      const stateChange = ['name', 'emailContact', 'restaurantAddress', 'menu', 'openingDate', 'selectedImages']
      const mandatoryElementStateChange = stateChange.some((el) => this.state[el] !== prevState[el]);
      if (mandatoryElementStateChange) {
        this.onUpdateRulesStatus()
      }
    }

    else if (!this.state.rulesStatus && this.state.restaurantId && this.state.token) {
      const result = await CallApi('GET', `rules-service/admin`, this.state.restaurantId, {}, this.state.token)
      this.setState({ rulesStatus: result[0]?.data?.state ?? "error" })
    }
  }

  /**
   * get refresh token from url
   */
  getTokenFromUrl = () => {
    const searchPath = window.location.search;
    const token = searchPath.substr(searchPath.indexOf("=") + 1);
    return token;
  };

  onUpdateRestaurantGeneral = (val) => {
    let { ...state } = this.state;
    state.emailContact = val.emailContact;
    state.description = val.description;
    state.slogan = val.slogan;
    state.phone = val.phone;
    state.name = val.name;
    this.setState(state);
  };

  onUpdateDisabledApp = (val) => {
    let { ...state } = this.state;
    state.disabledApp = val.disabledApp;

    this.setState(state);
  };

  onUpdateAddress = (val) => {
    let { ...state } = this.state;
    state.restaurantAddress.street = val.street;
    state.restaurantAddress.street_number = val.streetNumber;
    state.restaurantAddress.zip_code = val.zipCode;
    state.restaurantAddress.city = val.city;
    state.restaurantAddress.country = val.country;
    state.restaurantAddress.lat = val.lat;
    state.restaurantAddress.long = val.long;
    state.restaurantAddress.additional_address = val.additionalAddress;

    this.setState(state);
  };

  onUpdateOpeningDate = (val, stateCloseDate) => {
    this.setState({
      openingDate: val,
      displayScreenCloseDates: stateCloseDate,
    });
  };

  onUpdateClosingDate = (value, stateCloseDate) => {
    this.setState({
      closingDate: value,
      displayScreenCloseDates: stateCloseDate,
    });
  };

  onUpdateAlias = (value) => {
    this.setState({ restaurantAlias: value });
  };

  onUpdateLogistics = (val) => {
    let { ...state } = this.state;

    state.automaticallyValidated = val.automatically_validated;
    state.timePrepareOrder = val.time_prepare;
    state.currency = val.currency;
    state.orderShiftClose = val.order_shift_close;
    state.slotAuto = !!val.slot_auto;
    state.slotDuration = val.slot_duration;
    if (val.slot_max_mode) {
      const isOrderMode = val.slot_max_mode === "order";
      state.slotMaxOrderCount = isOrderMode ? val.slot_max_count : null;
      state.slotMaxProductsCount = isOrderMode ? null : val.slot_max_count;
    }
    this.setState(state);
  };

  onUpdateFacebookPage = (val) => {
    let { ...state } = this.state;
    state.facebookPageId = val;
    this.setState(state);
  };

  onUpdateImages = (val) => {
    let { ...state } = this.state;

    state.selectedImages = val.images;
    this.setState(state);
  };

  getRestaurantInfo = async () => {
    const token =
      this.getTokenFromUrl() || window.localStorage.getItem("refreshToken");
    try {
      let res = await fetcher("get", `restaurant/admin/info`, {}, token);
      if (
        res &&
        res.data &&
        res.data.result &&
        res.data.result.restaurantData
      ) {
        const infoRestaurant = res.data.result.restaurantData;
        this.setState({
          stripeAvailable: infoRestaurant.stripe_available,
          addressId: infoRestaurant.id_address,
          openingDate: infoRestaurant.opening_date,
          restaurantId: infoRestaurant.id,
          name: infoRestaurant.name,
          slogan:
            infoRestaurant.slogan && infoRestaurant.slogan.length <= 50
              ? infoRestaurant.slogan
              : "",
          email: infoRestaurant.email,
          emailContact: infoRestaurant.email_contact,
          phone: infoRestaurant.phone,
          idAddress: infoRestaurant.id_address,
          deliveryArea: infoRestaurant.delivery_area,
          deliveryActive: infoRestaurant.delivery_settings.active,
          deliveryMin: infoRestaurant.delivery_settings.minimum_amount,
          deliverySup: infoRestaurant.delivery_settings.surcharge,
          deliveryFreeSurcharge:
            infoRestaurant.delivery_settings.free_surcharge,
          takeAwayActive: infoRestaurant.take_away_settings.active,
          takeAwayMin: infoRestaurant.take_away_settings.minimum_amount,
          takeAwaySup: infoRestaurant.take_away_settings.surcharge,
          facebookUserId: infoRestaurant.facebook_userId,
          facebookPageId: infoRestaurant.facebook_pageId,
          disabledApp: infoRestaurant.disabled,
          closingDate: infoRestaurant.closing_date,
          restaurantAddress:
            res.data.result && res.data.result.restaurantAddress
              ? res.data.result.restaurantAddress
              : {},
          restaurantTimezone:
            res.data.result && res.data.result.restaurantTimezone
              ? res.data.result.restaurantTimezone
              : "",
          menu:
            res.data.result && res.data.result.resultMenu
              ? res.data.result.resultMenu
              : "",
          errors: "",
          mobile: false,
          loader: false,
          automaticallyValidated: infoRestaurant.automatically_validated,
          timePrepareOrder: infoRestaurant.time_prepare_order,
          currencies: infoRestaurant.currencies,
          currency: infoRestaurant.currency,
          restaurantAlias: infoRestaurant.alias,
          description: infoRestaurant.description,
          selectedImages: infoRestaurant.images,
          logRocket: !!infoRestaurant.logrocket,
          orderShiftClose: infoRestaurant.order_shift_close,
          slotAuto: !!infoRestaurant.slot_auto,
          slotDuration: infoRestaurant.slot_duration,
          slotMaxOrderCount: infoRestaurant.slot_max_order_count,
          slotMaxProductsCount: infoRestaurant.slot_max_products_count,
        });
      } else {
        const errorResponseData = res.response.data;
        if (errorResponseData.error.error?.code === "SUB_USER_NO_ACCESS") {
          return this.setState({
            unauthorizedSubUser: true,
            loader: false,
          });
        }
        this.setState({
          createAccountError: true,
          loader: false,
        });
      }
    } catch (e) {
      this.setState({
        errros: (
          <FormattedMessage
            id="indexAdmin.error"
            defaultMessage="une erreur s'est produite lors de la récupération de vos informations, veuillez essayer plus tard"
          />
        ),
      });
    }
  };

  isMobile = (isMobile) => {
    this.setState({
      mobile: isMobile,
    });
  };

  getStatus = (step, totalStep) => {
    if (step === totalStep) {
      return "active";
    }
    return `configuration-${step}.${totalStep}`;
  };

  onUpdateRulesStatus = async () => {
    const { rulesStatus, name, emailContact } = this.state;
    const { zip_code, city, country, street } = this.state.restaurantAddress;
    const mandatoryGeneralInfos = name && emailContact;
    const hasAddress = zip_code && city && country && street;
    const hasOpeningDates = Object.values(this.state.openingDate).some(
      (day) => day.length
    );
    const stepToValidate = [
      !!mandatoryGeneralInfos,
      !!hasAddress,
      hasOpeningDates,
      !!this.state.menu.length,
      !!this.state.selectedImages.length,
      !!this.state.token,
    ];
    const validatedSteps = stepToValidate.reduce(
      (acc, currValue) => acc + currValue
    );
    const newStatus = this.getStatus(validatedSteps, stepToValidate.length);
    if (newStatus === rulesStatus) {
      return;
    }
    const update = await CallApi(
      "PUT",
      `rules-service/admin`,
      this.state.restaurantId,
      { service: config.serviceName, state: newStatus },
      this.state.token
    );
    this.setState({ ...this.state, rulesStatus: newStatus });
    if (update.length && update[0].statusCode === 201) {
      await CallApi(
        "POST",
        "rules-service/admin",
        "",
        { service: config.serviceName, ids: { id: this.state.restaurantId } },
        this.state.token
      );
    }
  };

  render() {
    const accessToken = window.sessionStorage.getItem("accessToken");
    const isSubUser = !!accessToken ? subUserTools.isSubUserAccount(accessToken) : false;
    if (!this.state.loader && this.state.logRocket && this.isProd) {
      LogRocket.init(config.LOGROCKET_PROJECT);
      LogRocket.identify(`admin: ${this.state.email} `, {
        name: this.state.name,
        id: this.state.restaurantId,
      });
    }

    const { hash } = this.props.location;
    const commande = "#/commande";
    if (this.state.loader) {
      return (
        <div id="loader" className="secondary-loader">
          <Loader type="ThreeDots" color="#e84249" height="45" width="45" />
        </div>
      );
    }
    if (this.state.unauthorizedSubUser) {
      return <UnauthorizedServicePage />;
    }
    if (window.localStorage.getItem("login") && this.state.restaurantId) {
      return (
        <SnackbarProvider max={3}>
          {isSubUser && <SubUserHeader accessToken={accessToken} />}
          <Router>
            <div id="admin" className={this.state.mobile ? "active" : ""}>
              {hash && hash.includes(commande) ? (
                ""
              ) : (
                <Menu
                  accessToken={accessToken}
                  isMobile={this.isMobile}
                  stripeAvailable={this.state.stripeAvailable}
                />
              )}
              <Switch>
                <Redirect exact from="/" to="/general" />
                <PropsRoute
                  path="/general"
                  component={TemplateWrapper(General, {
                    title: "hello",
                    classNames: "container",
                  })}
                  name={this.state.name}
                  slogan={this.state.slogan}
                  restaurantId={this.state.restaurantId}
                  restaurantTimezone={this.state.restaurantTimezone}
                  description={this.state.description}
                  disabledApp={this.state.disabledApp}
                  emailContact={this.state.emailContact}
                  phone={this.state.phone}
                  onUpdateRestaurantGeneral={this.onUpdateRestaurantGeneral}
                  onUpdateDisabledApp={this.onUpdateDisabledApp}
                  token={this.state.token}
                />
                <PropsRoute
                  path="/adresse"
                  component={TemplateWrapper(Address)}
                  restaurantId={this.state.restaurantId}
                  addressId={this.state.addressId}
                  restaurantAddress={this.state.restaurantAddress}
                  token={this.state.token}
                  onUpdateAddress={this.onUpdateAddress}
                />
                <PropsRoute
                  path="/horaires"
                  component={TemplateWrapper(HoursV3)}
                  openingDate={this.state.openingDate}
                  restaurantId={this.state.restaurantId}
                  token={this.state.token}
                  onUpdateOpeningDate={this.onUpdateOpeningDate}
                  onUpdateClosingDate={this.onUpdateClosingDate}
                  closingDate={this.state.closingDate}
                  checkedSwitch={this.state.checkedSwitch}
                  displayScreenCloseDates={this.state.displayScreenCloseDates}
                />
                <PropsRoute
                  path="/carte"
                  component={TemplateWrapper(Carte)}
                  name={this.state.name}
                  concept={this.state.concept}
                  restaurantId={this.state.restaurantId}
                  menu={this.state.menu}
                  token={this.state.token}
                />
                <PropsRoute
                  path="/logistique"
                  component={TemplateWrapper(Logistics)}
                  restaurantId={this.state.restaurantId}
                  token={this.state.token}
                  onUpdateLogistics={this.onUpdateLogistics}
                  timePrepareOrder={this.state.timePrepareOrder}
                  automaticallyValidated={this.state.automaticallyValidated}
                  currencies={this.state.currencies}
                  currency={this.state.currency}
                  orderShiftClose={this.state.orderShiftClose}
                  slotAuto={this.state.slotAuto}
                  slotDuration={this.state.slotDuration}
                  slotMaxOrderCount={this.state.slotMaxOrderCount}
                  slotMaxProductsCount={this.state.slotMaxProductsCount}
                />
                <PropsRoute
                  path="/publication"
                  component={TemplateWrapper(Publication)}
                  restaurantId={this.state.restaurantId}
                  tokenLaddition={this.state.token}
                  facebookPageId={this.state.facebookPageId}
                  openingDate={this.state.openingDate}
                  disabledApp={this.state.disabledApp}
                  menuId={this.state.menuId}
                  token={this.state.token}
                  onUpdateFacebookPage={this.onUpdateFacebookPage}
                  onUpdateDisabledApp={this.onUpdateDisabledApp}
                  restaurantAlias={this.state.restaurantAlias}
                  onUpdateAlias={this.onUpdateAlias}
                  selectedImages={this.state.selectedImages}
                  onUpdateImages={this.onUpdateImages}
                />
                <PropsRoute
                  path="/presentation"
                  component={TemplateWrapper(Presentation)}
                  selectedImages={this.state.selectedImages}
                  onUpdateImages={this.onUpdateImages}
                  restaurantId={this.state.restaurantId}
                  token={this.state.token}
                />
                <PropsRoute
                  path="/commande"
                  component={TemplateWrapper(NewOrder)}
                />
                {this.state.stripeAvailable ? (
                  <PropsRoute
                    path="/stripe"
                    token={this.state.token}
                    component={TemplateWrapper(Stripe)}
                    restaurantId={this.state.restaurantId}
                  />
                ) : null}
              </Switch>
            </div>
          </Router>
        </SnackbarProvider>
      );
    } else if (
      !this.state.restaurantId &&
      window.localStorage.getItem("login") &&
      window.localStorage.getItem("refreshToken")
    ) {
      if (this.isProd) {
        const rt = window.localStorage.getItem("refreshToken");
        const email = JSON.parse(atob(rt.split(".")[1])).username;
        LogRocket.init(config.LOGROCKET_PROJECT);
        LogRocket.identify("Admin Connection Error", { name: email });
      }
      return <NoRecoveryRestaurantId />;
    } else {
      return <p />;
    }
  }
}
export default IndexAdmin;
